import { render, staticRenderFns } from "./retention-duration-feature-overview.vue?vue&type=template&id=39e7fe5e"
import script from "./retention-duration-feature-overview.vue?vue&type=script&lang=js"
export * from "./retention-duration-feature-overview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports